var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import memoize from 'lodash/memoize';
import i18next from 'i18next';
import { getQueryParams } from '../utils';
var DEFAULT_LANGUAGE = 'en';
export var createI18nInstance = function () {
    return i18next.createInstance();
};
export var i18nInstance = createI18nInstance();
export function getSiteTranslations(language, defaultTranslations, prefix, defaultLanguage) {
    if (defaultTranslations === void 0) { defaultTranslations = {}; }
    if (prefix === void 0) { prefix = 'messages'; }
    if (defaultLanguage === void 0) { defaultLanguage = DEFAULT_LANGUAGE; }
    if (language === defaultLanguage) {
        return Promise.resolve(defaultTranslations || {});
    }
    // locales are `fetch`ed and not `import`ed because
    // `bolt` SSR enviroment doesn't support webpack's `JsonpTemplatePlugin`
    // see also:
    //   https://github.com/wix-private/site-search/pull/369
    //   https://github.com/wix-private/site-search/commit/93a16dfbe1fcca9af7cc1abe88f0e0df222970c8
    return fetch(__webpack_public_path__ + "assets/locales/" + prefix + "_" + language + ".json").then(function (r) {
        if (!r.ok) {
            console.error("Can't load locale: " + language);
            return Promise.resolve(defaultTranslations || {});
        }
        return r.json();
    });
}
export default memoize(function i18n(params) {
    var _a;
    var _this = this;
    var _b;
    var language = params.language, translations = params.translations, defaultTranslations = params.defaultTranslations, waitForReact = params.waitForReact, defaultLanguage = params.defaultLanguage, prefix = params.prefix, parseMissingKeyHandler = params.parseMissingKeyHandler;
    var options = {
        lng: language,
        fallbackLng: defaultLanguage || DEFAULT_LANGUAGE,
        keySeparator: false,
        react: {
            wait: !!waitForReact,
        },
        parseMissingKeyHandler: parseMissingKeyHandler,
    };
    var instance = (_b = params.i18nInstance) !== null && _b !== void 0 ? _b : i18nInstance;
    if (translations) {
        options.resources = (_a = {},
            _a[language] = {
                translation: translations,
            },
            _a);
    }
    else {
        instance.use({
            type: 'backend',
            read: function (lang, namespace, callback) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, getSiteTranslations(lang, defaultTranslations, prefix, defaultLanguage)
                            .then(function (t) { return callback(null, t); })
                            .catch(function (error) { return callback(error); })];
                });
            }); },
        });
    }
    return instance.init(options);
});
export var getMultilingualLanguageFromQuery = function () {
    var queryParams = getQueryParams();
    var multilingualLanguage = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('lang');
    return multilingualLanguage || undefined;
};
export var getUserLanguageFromSDK = function (Wix) {
    return Wix.Utils.getLocale() || DEFAULT_LANGUAGE;
};
export var getSiteLanguageFromSDK = function (editorSDK) { return __awaiter(void 0, void 0, void 0, function () {
    var multilingualLanguage;
    return __generator(this, function (_a) {
        multilingualLanguage = getMultilingualLanguageFromQuery();
        return [2 /*return*/, multilingualLanguage || editorSDK.info.getRegionalLanguage('')];
    });
}); };
//# sourceMappingURL=index.js.map